<div class="spark" [class.spark--mini]="mini">
  <div class="spark__empty" *ngIf="!hasData && !mini">{{ 'audiences.trend.noData' | translate }}</div>

  <ng-container *ngIf="hasData">
    <div class="spark__kpis" *ngIf="!mini">
      <span class="spark__kpi">
        <strong>Ø {{ formatNumber(avgPerDay) }}</strong> {{ 'audiences.extractions.perDay' | translate }}
      </span>
      <span class="spark__sep">·</span>
      <span class="spark__kpi">{{ 'audiences.extractions.peak' | translate }} <strong>{{ formatNumber(peak) }}</strong></span>
      <span class="spark__sep" *ngIf="scheduledDays">·</span>
      <span class="spark__kpi" *ngIf="scheduledDays">
        <strong>{{ formatNumber(scheduledDays) }}</strong> {{ 'audiences.extractions.scheduledDays' | translate }}
      </span>
      <span class="spark__legend">
        <span class="spark__legend-item"><span class="dot dot--past"></span>{{ 'audiences.extractions.legendExtracted' | translate }}</span>
        <span class="spark__legend-item" *ngIf="scheduledDays"><span class="dot dot--future"></span>{{ 'audiences.extractions.legendScheduled' | translate }}</span>
      </span>
    </div>

    <div class="spark__chart">
      <svg [attr.viewBox]="'0 0 ' + vbW + ' ' + vbH" preserveAspectRatio="xMidYMid meet"
           (mousemove)="onMove($event)" (mouseleave)="onLeave()">
        <!-- y grid + ticks -->
        <g class="spark__grid" *ngIf="!mini">
          <line *ngFor="let t of yTicks" [attr.x1]="plotLeft" [attr.x2]="plotRight" [attr.y1]="t.y" [attr.y2]="t.y"></line>
        </g>
        <g class="spark__yticks" *ngIf="!mini">
          <text *ngFor="let t of yTicks" [attr.x]="plotLeft - 6" [attr.y]="t.y + 3" text-anchor="end">{{ formatNumber(t.value) }}</text>
        </g>

        <!-- areas + lines -->
        <path class="spark__area spark__area--past" [attr.d]="pastAreaPath"></path>
        <path class="spark__area spark__area--future" [attr.d]="futureAreaPath"></path>
        <path class="spark__line spark__line--past" [attr.d]="linePath"></path>
        <path class="spark__line spark__line--future" [attr.d]="futureLinePath"></path>

        <!-- today divider -->
        <line *ngIf="todayX !== null" class="spark__today" [attr.x1]="todayX" [attr.x2]="todayX"
              [attr.y1]="plotTop" [attr.y2]="baselineY"></line>

        <!-- x labels -->
        <g class="spark__xlabels" *ngIf="!mini">
          <ng-container *ngFor="let l of xLabels">
            <text *ngIf="!l.isToday" [attr.x]="l.x" [attr.y]="vbH - 8" text-anchor="middle">{{ l.text }}</text>
            <text *ngIf="l.isToday" [attr.x]="l.x" [attr.y]="vbH - 8" text-anchor="middle" class="is-today">
              {{ 'audiences.extractions.today' | translate }}
            </text>
          </ng-container>
        </g>

        <!-- hover marker -->
        <g *ngIf="!mini && hoverPoint as hp" class="spark__hover">
          <line [attr.x1]="hp.x" [attr.x2]="hp.x" [attr.y1]="plotTop" [attr.y2]="baselineY"></line>
          <circle [attr.cx]="hp.x" [attr.cy]="hp.y" r="3.5" [class.is-future]="hp.isFuture"></circle>
        </g>
      </svg>

      <div class="spark__tooltip" *ngIf="!mini && hoverPoint as hp" [style.left.%]="hoverLeftPct">
        <span class="spark__tooltip-date">{{ hp.date }}</span>
        <span class="spark__tooltip-val">
          <span class="dot" [class.dot--future]="hp.isFuture" [class.dot--past]="!hp.isFuture"></span>
          {{ formatNumber(hp.value) }}
          {{ (hp.isFuture ? 'audiences.extractions.legendScheduled' : 'audiences.extractions.legendExtracted') | translate }}
        </span>
      </div>
    </div>
  </ng-container>
</div>
